import { getUserRole } from "../../../../../../service/auth";
import { Roles } from "../../../../../../utils/enums";
import { ActivitySection, TabsItem } from "../enums";
import { StateLogbook } from "../types";

const role = getUserRole();

export const initialState: StateLogbook = {
    activitySection: ActivitySection.USER_LIST,
    uuid: {
        MAIN_ACTIVITY:null,
        MY_ACTIVITY:null,
        ONE_USER_ACTIVITY:null,
        USER_LIST_ACTIVITY:null
    },
    err: {
        MAIN_ACTIVITY:false,
        MY_ACTIVITY:false,
        ONE_USER_ACTIVITY:false,
        USER_LIST_ACTIVITY:false
    },
    loading: {
        MAIN_ACTIVITY: false,
        MY_ACTIVITY: false,
        ONE_USER_ACTIVITY: false,
        USER_LIST_ACTIVITY: false
    },
    activityRegister: {
        userTable: [],
        activity: {
            userList: [],
            total: 0,
            usersMark: [],
        },
        form: {
            userSelecteds: [],
            usersSearchs: []
        },
        usersChecks: [],
        usersUnChecks: [],
        allSelecteds: false
    },
    myActivity: {
        data: {
            id: '1',
            amount: 6,
            userName: 'Usuario veintiuno nelumbo',
            userType: 'Tipo de usuario',
            area: 'Area',
            curp: 'asdasd3',
            department: 'Departamento',
            division: 'Division',
            role: 'Rol',
            activityList: [],
            completedLogs: 0,
            pendingLogns: 0
        },
        total: 0,
        usersMark: []
    },
    loadings: {
        USER_LIST: false,
        GET_ACTIVITIES: false
    },
    tab: role == Roles.PARTNER ? TabsItem.MY_ACTIVITY : TabsItem.ACTIVITY_REGISTER
}